// extracted by mini-css-extract-plugin
module.exports = {"carouselDots":"carousel_dots-module--carouselDots--3v-DV","active":"carousel_dots-module--active--1FB8J"};